import React from 'react';

import { ImageGallery } from 'components/common/ImageGallery';
import { PageContent } from 'components/page/PageContent';
import { PageDescription } from 'components/page/PageDescription';
import { PageTitle } from 'components/page/PageTitle';
import { ForYouSecondToThird } from 'components/common/connectionLines/ForYouSecondToThird';
import { WebImageProps } from 'types/webImageProps';
import { Wrapper } from './atoms/Wrapper';
import { ImageGalleryWrapper } from './atoms/ImageGalleryWrapper';

interface Props {
    title: string;
    description: string;
    imageGallery: Array<WebImageProps>;
}
export const GalleryIntro: React.FC<Props> = ({ title, description, imageGallery }) => (
    <Wrapper>
        <PageContent>
            <PageTitle>{title}</PageTitle>
            <PageDescription>{description}</PageDescription>
        </PageContent>
        <ImageGalleryWrapper>
            <ImageGallery images={imageGallery} />
            <ForYouSecondToThird />
        </ImageGalleryWrapper>
    </Wrapper>
);
